var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    stroke: "#27295B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1968 12.39L23.6091 16.8025L14.0279 26.3841L10.094 26.8184C9.56734 26.8767 9.12239 26.4314 9.18098 25.9047L9.6187 21.9678L19.1968 12.39ZM26.3382 11.7331L24.2664 9.66121C23.6202 9.01495 22.5721 9.01495 21.9258 9.66121L19.9768 11.6103L24.3891 16.0229L26.3382 14.0737C26.9844 13.4271 26.9844 12.3793 26.3382 11.7331Z",
    fill: "#27295B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdits);
export default __webpack_public_path__ + "static/media/Edits.ce89f0bb60253a0a74c29cf8927932ac.svg";
export { ForwardRef as ReactComponent };